import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { BaseService } from './base-service';
import { ConfirmationService } from './confirmation.service';
import { GroupDtoPage, CreateGroupRequest, UpdateGroupRequest, GroupDto } from '@api/backend-connector/models';
import { GroupsApi } from '@api/backend-connector/services';

const toasts = {
  createSuccessSummary: 'i18n.GroupToast.createSuccessSummary',
  createSuccessDetail: 'i18n.GroupToast.createSuccessDetail',
  createFailSummary: 'i18n.GroupToast.createFailSummary',
  createFailDetail: 'i18n.GroupToast.createFailDetail',

  updateSuccessSummary: 'i18n.Toast.updateSuccessSummary',
  updateSuccessDetail: 'i18n.Toast.updateSuccessDetail',
  updateFailSummary: 'i18n.Toast.updateFailSummary',
  updateFailDetail: 'i18n.Toast.updateFailDetail',

  deleteSuccessSummary: 'i18n.GroupToast.deleteSuccessSummary',
  deleteSuccessDetail: 'i18n.GroupToast.deleteSuccessDetail',
  deleteFailSummary: 'i18n.GroupToast.deleteFailSummary',
  deleteFailDetail: 'i18n.GroupToast.deleteFailDetail',
};

@Injectable({
  providedIn: 'root',
})
export class GroupsService extends BaseService {
  private readonly groupsApi = inject(GroupsApi);
  readonly toasts = toasts;

  readonly refresh$ = new BehaviorSubject<void>(undefined);

  listGroups(params: Parameters<typeof GroupsService.prototype.groupsApi.listGroups>[0]): Observable<GroupDtoPage> {
    return this.groupsApi.listGroups(params);
  }

  getGroup(id: string): Observable<GroupDto> {
    return this.groupsApi.getGroup({ id });
  }

  createGroup(request: CreateGroupRequest) {
    return this.groupsApi.createGroup({ body: request });
  }

  updateGroup(id: string, request: UpdateGroupRequest) {
    return this.groupsApi.updateGroup({ id, body: request });
  }

  deleteGroup(id: string) {
    return this.groupsApi.deleteGroup({ id });
  }

  async openRemoveCollaboratorConfirmationDialog(confirmationService: ConfirmationService, label: string) {
    return confirmationService.confirm({
      header: this.translateService.instant(this.confirmDelete.message),
      message: this.translateService.instant(this.confirmDelete.header, { label }),
      confirmLabel: this.translateService.instant(this.confirmDelete.confirmLabel),
    });
  }
}
